module.exports = __webpack_public_path__ + "img/logo.97356ee2.svg";